export const MAP_LAT_LNG_PRECISION = 6
export const MAP_NAME = 'explore.map'
export const MAP_REGION = 'ap-southeast-1'
